import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

export default function CustomCollectionTableRow({ 
  collection, 
  isSelected, 
  onSelectCollection 
}) {
  const { t } = useTranslation()
  return (
    <tr className="hover:bg-gray-100">
      <td className="py-2 px-4 border-b border-gray-300 text-center">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelectCollection(collection._id || collection.id, e.target.checked)}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
        />
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <Link 
            to={`/custom-collections/details/${collection._id || collection.id}`}
            className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
          >
            {collection.name}
          </Link>
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          {t('customCollections.list.table.fieldsCount', { count: collection.fields ? collection.fields.length : 0 })}
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <div className="flex flex-col text-xs text-gray-700">
          <span className="font-semibold">
            {t('customCollections.list.table.sortField')}: {collection.sortField || t('customCollections.list.table.createdValue')}
          </span>
          <span>
            {t('customCollections.list.table.sortDirection')}: {t(`customCollections.list.sortDirections.${collection.sortDirection || 'desc'}`)}
          </span>
        </div>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <span
          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
            collection.visibleInMenu ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'
          }`}
        >
          {collection.visibleInMenu ? t('customCollections.list.table.yes') : t('customCollections.list.table.no')}
        </span>
      </td>
      <td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {moment(collection.created || collection.createdAt).format('YYYY-MM-DD')}
        </span>
      </td>
    </tr>
  );
}
